import { css } from '@microsoft/fast-element';

export const ValidationGridStyles = css`
  .vppa-grids-container {
    margin-top: 16px;
    width: 100%;
    height: 220px;
  }

  .vppa-grids {
    display: block;
    height: 100%;
  }

  .ag-theme-genesis-rapid-dark-dark .ag-row {
    --ag-font-size: 12px;
  }
`;
